<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body">
            <compose-box :message="message" @cancel="$parent.$parent.$emit('update:active', false)" @sent="$parent.$parent.$emit('update:active', false)" />
        </section>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import ComposeBox from './ComposeBox.vue'
    export default {
        components: { ComposeBox },
        props: {
            message: {
                default: null,
                required: false,
                type: Object,
            },
            title: {
                default: 'Compose',
                required: false,
                type: String,
            },
        },
        data() {
            return {
                selectedItem: null,
                query: '',
                results: [],
                data: null,
                item: {
                }
            }
        },
        mounted() {
            this.data = this.reference
        },
        methods: {
            handleSave() {
                this.$emit('modalButtonClick', this.data)
                this.$parent.$parent.$emit('update:active', false)
            },
            handleSelect(item) {
                this.data = item
            },
            handleSearch() {
                _.debounce(function () {
                    if (this.query && this.query.length > 1) {
                        let params = {q: this.query, isWork: true }
                        axios.get('/api/search', { params })
                            .then(res => {
                                this.results = res.data.data
                                return { data: { data: this.results }}
                            })
                    } else {
                        this.results = []
                    }
                }, 250)()
            },
        }
    }
</script>
<style>
.modal-card {
  width: auto;
  min-width: 1000px; }

</style>
